<select
  id="pp"
  class="per-page-select"
  [(ngModel)]="itemsPerPage"
  (change)="changeItemsPerPage()"
>
  <option [value]="50">50pp</option>
  <option [value]="100">100pp</option>
  <option [value]="250">250pp</option>
  <option [value]="500">500pp</option>
  <option [value]="1000">1000pp</option>
  <option [value]="99999999">All</option>
</select>
<ul *ngIf="totalPages > 1" class="transferPagination">
  <li *ngIf="page > 1">
    <button class="misc__button" (click)="changePage(page - 1)">&lt;</button>
  </li>
  <li
    *ngFor="let pageOpt of pages; let i = index"
    class="paginationItem"
  >
    <button
      class="paginationLink"
      (click)="changePage(pageOpt)"
      [class.current]="page == pageOpt"
    >
      {{ pageOpt }}
    </button>
  </li>
  <li *ngIf="page < totalPages">
    <button class="misc__button" (click)="changePage(page + 1)">&gt;</button>
  </li>
</ul>